
import {defineComponent} from "vue";
import {CbStructureMixin} from "@/components/layouts/content-pages/wysiwyg/structures/CbStructureMixin";
import {BannerSlotContentRestDtoModel} from "@/models/BannerSlotContentRestDtoModel";
import {CodeDescriptionRestDto, ContentOverviewRestDto} from "@/api/pharma-cms-content-block/models";
import {DpException} from "@/exception/DpException";
import BaseSpinner from "@/components/UI/Bootstrap/BaseSpinner.vue";
import InputSelect from "@/components/UI/InputSelect.vue";
import {NormalContentBlockRestService} from "@/services/rest/cms-content-block/NormalContentBlockRestService";

export default defineComponent({
  name: "CbBannerSlot",
  components: {InputSelect, BaseSpinner},
  extends: CbStructureMixin,
  data: () => ({
    internalCbId: undefined as string | null | undefined,
    bannerSlots: [] as ContentOverviewRestDto[],
  }),
  computed: {
    bannerSlotOptions(): CodeDescriptionRestDto[] {
      return this.bannerSlots.map((bannerSlot: ContentOverviewRestDto) => {
        return {code: bannerSlot.id, description: bannerSlot.title ?? ''} as CodeDescriptionRestDto;
      });
    },
  },
  methods: {
    /**
     * This block does not own content of its own: it only points at an existing banner slot, so it
     * loads the pickable slots instead of a content block.
     */
    async reloadContent(): Promise<void> {
      this.isReady = false;

      try {
        this.internalCbId = this.cbId;

        this.onCopyCpAbstractChanged();

        this.bannerSlots = await NormalContentBlockRestService.getInstance()
          .findContentBlockOverview('BANNER_SLOT');
      } catch (exceptions: any) {
        this.setExceptions(exceptions);
      }

      this.isReady = true;
    },
    async submit(): Promise<string | null> {
      if (!this.internalCbId) {
        throw [new DpException(this.$t('Banner slot needs to be selected.'))];
      }

      // Nothing to persist here; the column stores the selected slot as its cb_id.
      return this.internalCbId;
    },
    getDefaultCbModel(): BannerSlotContentRestDtoModel {
      return BannerSlotContentRestDtoModel.createWithDefaults();
    },
  }
});
